<template>
  <div id="app">
    <component :is="layout">
      <router-view :key="$route.path"/>
    </component>
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<script>
  import ManagerLayout from "src/resources/views/logistic_manager/manager/layout/Layout.vue";
  import ShipperLayout from "src/resources/views/logistic_manager/shipper/layout/Layout.vue";
  import TransporterLayout from "src/resources/views/logistic_manager/transporter/layout/Layout.vue";
  import RiskLayout from "src/resources/views/logistic_manager/riskManager/layout/Layout.vue"
  import BrokerLayout from "src/resources/views/logistic_manager/broker/layout/Layout.vue"
  import FintechLayout from "src/resources/views/finance/fintech/layout/Layout"
  import CustomerLayout from "src/resources/views/logistic_manager/customer/layout/Layout"
  import FourPlLayout from "src/resources/views/logistic_manager/fourPl/layout/Layout"
  import AuditorLayout from "src/resources/views/logistic_manager/auditor/layout/Layout"
  import FinanceManagerLayout from "src/resources/views/finance/financeManager/Layout/Layout"
  import SupplierLayout from "src/resources/views/logistic_manager/supplier/layout/Layout"
  import {mapGetters} from "vuex";
  import UserRole from "./util/valueObjects/userRole";
  import router from "./http/router";
  import * as Cookies from "js-cookie";
  import NoPermission from "./resources/views/errors/NoPermission";
  import { reloadOnChunkError } from "./util/chunkReload";

  export default {
    data(){
      return{
        snowConf: {
          windPower : 1,
          speed : 3,
          count : 12,
          size : 5,
          opacity : 1,
          images: [
            'https://pngimg.com/uploads/heart/heart_PNG51183.png',
            ]
        },

        // snowConf: {
        //   windPower : 1,
        //   speed : 3,
        //   count : 12,
        //   // size : 8,
        //   opacity : 1,
        //   // images: [
        //   //   'https://webstockreview.net/images/confetti-clipart-single.png',
        //   //   'https://webstockreview.net/images/streamers-clipart-green-1.png',
        //   //   'https://pngimg.com/uploads/heart/heart_PNG51183.png',
        //   //   ]
        //   color: "#ff0586"
        // },
        snowConf2: {
          windPower : 1,
          speed : 3,
          count : 12,
          // size : 8,
          opacity : 1,
          // images: [
          //   'https://webstockreview.net/images/confetti-clipart-single.png',
          //   'https://webstockreview.net/images/streamers-clipart-green-1.png',
          //   'https://pngimg.com/uploads/heart/heart_PNG51183.png',
          //   ]
          color: "#8aff05"
        },
        show: false
      }
    },
    methods: {

      initializeLayout() {
        if (!this.$rtl.isRTL) {
          // Just make sure rtl css is off when we are not on rtl
          this.$rtl.disableRTL();
        }
      }
    },
    mounted() {
      this.show = false;
      this.initializeLayout();
    },

    computed: {
      layout() {
        if (this.$route.matched.length === 0) {
          return;
        }

        if (this.$route.meta.visibilityPermission) {
          if (Array.isArray(this.$route.meta.visibilityPermission)) {
            if (this.$canAny(this.$route.meta.visibilityPermission) === false) {
              return NoPermission;
            }
          } else {
            if (this.$can(this.$route.meta.visibilityPermission) === false) {
              return NoPermission;
            }
          }
        }

        if (this.$route.meta.layout) {
          if (typeof this.$route.meta.layout === "function") {
            return reloadOnChunkError(this.$route.meta.layout);
          }

          return this.$route.meta.layout;
        }

        switch (Cookies.getJSON("token").user.role.id) {
          case UserRole.MANAGER.index:
            return ManagerLayout;
          case UserRole.SHIPPER.index:
            return ShipperLayout;
          case UserRole.TRANSPORTER.index:
            return TransporterLayout;
          case UserRole.RISK_MANAGER.index:
            return RiskLayout;
          case UserRole.BROKER.index:
            return BrokerLayout;
          case UserRole.FINTECH.index:
            return FintechLayout;
          case UserRole.CUSTOMER.index:
            return CustomerLayout;
          case UserRole.FOUR_PL.index:
            return FourPlLayout;
          case UserRole.AUDITOR.index:
            return AuditorLayout;
          case UserRole.FINANCE_MANAGER.index:
            return FinanceManagerLayout;
          case UserRole.SUPPLIER.index:
            return SupplierLayout;
        }

      }
    }
  };
</script>
